import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

type Status = 'active' | 'pending' | 'inactive';

const statusStyles: Record<Status, string> = {
  active: 'bg-green-50 text-green-700 border-green-200 hover:bg-green-50',
  pending: 'bg-amber-50 text-amber-700 border-amber-200 hover:bg-amber-50',
  inactive: 'bg-gray-100 text-gray-500 border-gray-200 hover:bg-gray-100',
};

const statusLabels: Record<Status, string> = {
  active: 'Active',
  pending: 'Pending',
  inactive: 'Inactive',
};

interface StatusBadgeProps {
  status: Status;
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  return (
    <Badge
      variant="outline"
      className={cn('text-xs font-medium', statusStyles[status], className)}
    >
      {statusLabels[status]}
    </Badge>
  );
}
